import { __assign, __awaiter, __extends, __generator } from "tslib";
import { RestCommands, GraphQLOperations, CartEvents, PLACE_ORDER_URL } from '../constants';
import { TrackEventName } from '@wix/wixstores-client-core/dist/es/src/types/track-event';
import { query as getCartServiceQuery } from '../../graphql/getCartService.graphql';
import { compact } from '../../lib/compact';
import { BaseApi } from '../BaseApi';
import { actualPrice, actualSku } from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
var CartApi = /** @class */ (function (_super) {
    __extends(CartApi, _super);
    function CartApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartApi.prototype.commandPost = function (command, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post(this.endpoints.cartCommmands(command), data)];
            });
        });
    };
    CartApi.prototype.fetchCart = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: variables,
                            query: getCartServiceQuery,
                            operationName: GraphQLOperations.GetCartService,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.cartService.cart];
                }
            });
        });
    };
    CartApi.prototype.removeItem = function (data, _a) {
        var cart = _a.cart, item = _a.item;
        return __awaiter(this, void 0, void 0, function () {
            var product, nextCart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        product = item.product;
                        return [4 /*yield*/, this.postAndReturnCart(RestCommands.CartRemoveItem, data)];
                    case 1:
                        nextCart = _b.sent();
                        this.biService.removeItem(cart, product);
                        this.publishCartChange({ cart: nextCart, shouldOpenCart: false });
                        this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
                            id: product.id,
                            name: product.name,
                            price: actualPrice(product),
                            quantity: item.quantity,
                            sku: actualSku(product),
                            currency: cart.convertedCurrencyFormat.code,
                            type: product.productType,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.updateItemQuantity = function (data, _a) {
        var productId = _a.productId, cart = _a.cart;
        return __awaiter(this, void 0, void 0, function () {
            var nextCart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.postAndReturnCart(RestCommands.CartUpdateItem, data)];
                    case 1:
                        nextCart = _b.sent();
                        this.biService.updateItemQuantity(cart, productId);
                        this.publishCartChange({ cart: nextCart, shouldOpenCart: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.updateBuyerNote = function (data, _a) {
        var cart = _a.cart;
        return __awaiter(this, void 0, void 0, function () {
            var note;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        note = compact(data);
                        return [4 /*yield*/, this.commandPost(RestCommands.CartUpdateBuyerNote, note)];
                    case 1:
                        _b.sent();
                        this.biService.updateBuyerNote(cart, !!note.content);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setDestinationForEstimation = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandPost(RestCommands.CartSetCartDestinationForEstimation, data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCartShippingAddressesForFastFlowEstimation = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandPost(RestCommands.SetCartShippingAddressesForFastFlowEstimation, data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCartAddress = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandPost(RestCommands.SetCartAddressesAndDestinationFromSingleAddress, data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCartBillingAddress = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    //billingAddress
                    return [4 /*yield*/, this.commandPost(RestCommands.SetCartBillingAddress, data)];
                    case 1:
                        //billingAddress
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setShippingOption = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandPost(RestCommands.CartSelectShippingOption, data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.applyCoupon = function (data, _a) {
        var cart = _a.cart, isMember = _a.isMember;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.biService.applyCoupon(cart, data.code, isMember);
                        return [4 /*yield*/, this.commandPost(RestCommands.CartApplyCoupon, data)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.removeCoupon = function (data, _a) {
        var cart = _a.cart, isMember = _a.isMember;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.biService.removeCoupon(cart, isMember);
                        return [4 /*yield*/, this.commandPost(RestCommands.CartRemoveCoupon, data)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.postAndReturnCart = function (command, data) {
        return this.commandPost(command, data).then(function (res) { return res.cartSummary; });
    };
    CartApi.prototype.publishCartChange = function (_a) {
        var cart = _a.cart, shouldOpenCart = _a.shouldOpenCart;
        this.siteStore.pubSub.publish(CartEvents.Changed, __assign(__assign({}, cart), { eventOptions: { shouldOpenCart: shouldOpenCart }, extraParams: { origin: this.origin } }), false);
    };
    CartApi.prototype.placeOrder = function (_a) {
        var cartId = _a.cartId, paymentId = _a.paymentId, shouldRedirect = _a.shouldRedirect, isPickupFlow = _a.isPickupFlow, forceLocale = _a.forceLocale, deviceType = _a.deviceType, inUserDomain = _a.inUserDomain;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.post(PLACE_ORDER_URL.replace('{cartId}', cartId), null, {
                        paymentId: paymentId,
                        shouldRedirect: shouldRedirect,
                        isPickupFlow: isPickupFlow,
                        forceLocale: forceLocale,
                        deviceType: deviceType,
                        inUserDomain: inUserDomain,
                    })];
            });
        });
    };
    return CartApi;
}(BaseApi));
export { CartApi };
//# sourceMappingURL=CartApi.js.map